// base configuration for axios and urls
//raed this article: https://medium.com/canariasjs/vue-api-calls-in-a-smart-way-8d521812c322
import store from '@/core/services/store';
import axios from 'axios';
axios.interceptors.request.use((req) => {
  req.headers.Authorization =
    'Bearer ' + localStorage.getItem('taksan_supplier_access_token');
  return req;
});
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      store.dispatch('oidc/authenticateOidc');
    }
    return Promise.reject(error);
  }
);
export default axios;
